import { render, staticRenderFns } from "./CampaignInfoForm.vue?vue&type=template&id=395e4de1"
import script from "./CampaignInfoForm.vue?vue&type=script&lang=js"
export * from "./CampaignInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports